// Trust bands & thresholds — from backend score-distribution buckets.
// Restricted 0-29 · New 30-54 · Baseline 55-74 · Trusted 75-89 · High Trust 90-100.
export const SCORE_BANDS = [
  { name: "Restricted", min: 0 },
  { name: "New", min: 30 },
  { name: "Baseline", min: 55 },
  { name: "Trusted", min: 75 },
  { name: "High Trust", min: 90 },
];

export function bandIndexForScore(score = 0) {
  return SCORE_BANDS.reduce((acc, b, i) => (score >= b.min ? i : acc), 0);
}

export function bandForScore(score = 0) {
  return SCORE_BANDS[bandIndexForScore(score)];
}
